import { MessageMedium } from 'modules/graphql';
import { SystemConversionEventDefinition } from '../types';

type MetricsMediumWinningCriteriaMap = {
  [k in MessageMedium]: {
    [key: string]: string;
  };
};

type SettingsMetricsMediumWinningCriteriaMap = {
  [k in MessageMedium]: {
    label: string;
    value: SystemConversionEventDefinition;
  }[];
};

type MetricMediumSendsMap = {
  [k in MessageMedium]: string;
};

type MetricsMediumDefaultsMap = {
  [k in MessageMedium]: string[];
};

export const metricsMediumWinningCriteriaDefaults: MetricsMediumWinningCriteriaMap = {
  [MessageMedium.Email]: {
    Opens: 'UniqueEmailOpenOrClick',
    Clicks: 'UniqueEmailClick',
  },
  [MessageMedium.Push]: {
    Opens: 'UniquePushOpen',
  },
  [MessageMedium.SMS]: {
    Clicks: 'UniqueSMSClick',
  },
  [MessageMedium.WebPush]: {
    Clicks: 'UniqueWebPushClick',
  },
  [MessageMedium.InApp]: {
    Opens: 'UniqueInAppOpen',
    Clicks: 'UniqueInAppClick',
  },
};

export const settingsMetricsMediumWinningCriteriaDefaults: SettingsMetricsMediumWinningCriteriaMap =
  {
    [MessageMedium.Email]: [
      {
        label: 'settings.systemEvents.opens',
        value: SystemConversionEventDefinition.Opens,
      },
      {
        label: 'settings.systemEvents.clicks',
        value: SystemConversionEventDefinition.Clicks,
      },
    ],
    [MessageMedium.Push]: [
      {
        label: 'settings.systemEvents.opens',
        value: SystemConversionEventDefinition.Opens,
      },
    ],
    [MessageMedium.SMS]: [
      {
        label: 'settings.systemEvents.clicks',
        value: SystemConversionEventDefinition.Clicks,
      },
    ],
    [MessageMedium.WebPush]: [
      {
        label: 'settings.systemEvents.clicks',
        value: SystemConversionEventDefinition.Clicks,
      },
    ],
    [MessageMedium.InApp]: [
      {
        label: 'settings.systemEvents.opens',
        value: SystemConversionEventDefinition.Opens,
      },
      {
        label: 'settings.systemEvents.clicks',
        value: SystemConversionEventDefinition.Clicks,
      },
    ],
  };

export const metricsMediumSendDefaults: MetricMediumSendsMap = {
  [MessageMedium.Email]: 'TotalEmailSend',
  [MessageMedium.Push]: 'TotalPushSend',
  [MessageMedium.SMS]: 'TotalSMSSend',
  [MessageMedium.WebPush]: 'TotalWebPushSend',
  [MessageMedium.InApp]: 'TotalInAppSend',
};

export const metricsMediumDefaults: MetricsMediumDefaultsMap = {
  [MessageMedium.Email]: [
    metricsMediumSendDefaults.Email,
    metricsMediumWinningCriteriaDefaults.Email.Opens,
    metricsMediumWinningCriteriaDefaults.Email.Clicks,
  ],
  [MessageMedium.Push]: [
    metricsMediumSendDefaults.Push,
    metricsMediumWinningCriteriaDefaults.Push.Opens,
  ],
  [MessageMedium.SMS]: [
    metricsMediumSendDefaults.SMS,
    metricsMediumWinningCriteriaDefaults.SMS.Clicks,
  ],
  [MessageMedium.WebPush]: [
    metricsMediumSendDefaults.WebPush,
    metricsMediumWinningCriteriaDefaults.WebPush.Clicks,
  ],
  [MessageMedium.InApp]: [
    metricsMediumSendDefaults.InApp,
    metricsMediumWinningCriteriaDefaults.InApp.Opens,
    metricsMediumWinningCriteriaDefaults.InApp.Clicks,
  ],
};

export enum MetricCategory {
  DEFAULT = 'defaultMetrics',
  CONVERSION = 'conversionMetrics',
  ADDITIONAL = 'additionalMetrics',
}

/**
 * This will be used to identify different metrics
 *
 * The reason why we can't use MetricCategory to identify
 * is because it clubs the unique and total conversions
 * into the same category.
 */
export enum MetricIdentifier {
  SYSTEM_METRICS = '__metrics__',
  CONVERSION = '__conversion__',
  UNIQUE_CONVERSION = '__unique_conversion__',
}

export const CONVERSION = 'Conversions';
export const UNIQUE_CONVERSION = 'UniqueConversions';
export const CONVERSION_EVENT_METRICS = [CONVERSION, UNIQUE_CONVERSION];
